/* unplugin-vue-components disabled */import { ElLoadingDirective as __unplugin_directives_0 } from 'element-plus/es';import 'element-plus/es/components/loading/style/css';
import { ElDialog as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElCheckboxGroup as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/checkbox-group/style/css';
import { ElCheckbox as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/checkbox/style/css';
import { ElPagination as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/pagination/style/css';
import { ElTable as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/table/style/css';
import { ElTableColumn as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/table-column/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6ba2562c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "table-action"
};
const _hoisted_2 = {
  class: "top-left"
};
const _hoisted_3 = {
  class: "top-right"
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  style: {
    "font-size": "12px",
    "font-wieght": "400"
  }
};
const _hoisted_7 = {
  style: {
    "color": "#5F6379"
  }
};
const _hoisted_8 = {
  style: {
    "color": "#3F6DF8"
  }
};
const _hoisted_9 = {
  style: {
    "color": "#F79E13"
  }
};
const _hoisted_10 = {
  class: "center marginB10"
};
const _hoisted_11 = {
  class: "center"
};
const _hoisted_12 = {
  class: "dialog-footer"
};
import localforage from 'localforage';
import { useModel } from '../../hooks';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    tableColumns: {
      type: Array,
      default: () => []
    },
    isCustomHeader: {
      type: Boolean,
      default: true
    },
    tableKey: {
      type: String,
      default: ''
    },
    tableData: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: true
    },
    pagination: {
      type: Boolean,
      default: false
    },
    // 当前是第几页
    currentPage: {
      type: Number,
      default: 1
    },
    // 当前一页多少条数据
    pageSize: {
      type: Number,
      default: 10
    },
    // 显示分页数据多少条的选项
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 40]
    },
    // 数据总条数
    total: {
      type: Number,
      default: 0
    },
    // 显示分页的对齐方式
    paginationAlign: {
      type: String,
      default: 'right'
    }
  },
  emits: ['size-change', 'current-change', 'current-page', 'page-size', 'multiple-select'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    let emits = __emit;
    const customTable = ref(null);
    const visible = ref(false);
    const columns = ref([]);
    const confirmLoading = ref(false);
    const name = ref(`${props.tableKey ? '-' + props.tableKey : ''}`);
    const selected = ref([]);
    const handleCustom = () => {
      visible.value = true;
    };
    const handleOk = () => {
      localforage.setItem(name.value, toRaw(selected.value)).then(() => {
        columns.value = props.tableColumns.filter(item => item.isForce || selected.value.includes(item.prop));
        visible.value = false;
      });
    };
    const handleCancel = () => {
      visible.value = false;
    };
    const currentPageModel = useModel(() => props.currentPage, val => emits('current-page', val));
    const pageSizeModel = useModel(() => props.pageSize, val => emits('page-size', val));
    const _total = computed(() => {
      return props.total || props.tableData.length;
    });
    // 分页的每一页数据变化
    let handleSizeChange = val => {
      emits('size-change', val);
    };
    // 分页页数改变
    let handleCurrentChange = val => {
      emits('current-change', val);
    };
    // 表格分页的排列方式
    let justifyContent = computed(() => {
      if (props.paginationAlign === 'left') return 'flex-start';else if (props.paginationAlign === 'right') return 'flex-end';else return 'center';
    });
    const clearSort = () => {
      if (customTable.value) {
        customTable.value.clearSort();
      }
    };
    watch(() => props.tableColumns, val => {
      if (val && val.length) {
        localforage.getItem(`${props.tableKey ? '-' + props.tableKey : ''}`).then(data => {
          if (data) {
            columns.value = val.filter(item => item.isForce || data.includes(item.prop));
          } else {
            columns.value = val.filter(item => item.isForce || item.isDefault);
          }
          selected.value = columns.value.map(item => item.prop);
        });
      }
    }, {
      immediate: true,
      deep: true
    });
    __expose({
      clearSort
    });
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_el_table_column = __unplugin_components_1;
      const _component_el_table = __unplugin_components_2;
      const _component_el_pagination = __unplugin_components_3;
      const _component_el_checkbox = __unplugin_components_4;
      const _component_el_checkbox_group = __unplugin_components_5;
      const _component_el_dialog = __unplugin_components_6;
      const _directive_loading = __unplugin_directives_0;
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "topLeft")]), _createElementVNode("div", _hoisted_3, [_renderSlot(_ctx.$slots, "top"), __props.isCustomHeader ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        class: "primary-btn marginL10",
        onClick: handleCustom
      }, {
        default: _withCtx(() => [_createTextVNode("自定义表头")]),
        _: 1
      })) : _createCommentVNode("", true)])]), _withDirectives((_openBlock(), _createBlock(_component_el_table, _mergeProps({
        ref_key: "customTable",
        ref: customTable
      }, _ctx.$attrs, {
        data: __props.tableData
      }), {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columns), item => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: item.prop
          }, [item.prop && !item.action ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 0,
            label: item.label,
            prop: item.prop,
            width: item.width,
            "min-width": item.minWidth,
            align: item.align,
            sortable: item.sortable,
            fixed: item.fixed
          }, {
            header: _withCtx(() => [item.header ? _renderSlot(_ctx.$slots, item.header, {
              key: 0
            }) : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.label), 1))]),
            default: _withCtx(scope => [item.slot ? _renderSlot(_ctx.$slots, item.slot, {
              key: 0,
              scope: scope
            }) : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(scope.row[item.prop] || '-'), 1))]),
            action: _withCtx(scope => [_renderSlot(_ctx.$slots, "action", {
              scope: scope
            })]),
            _: 2
          }, 1032, ["label", "prop", "width", "min-width", "align", "sortable", "fixed"])) : _createCommentVNode("", true)], 64);
        }), 128))]),
        _: 3
      }, 16, ["data"])), [[_directive_loading, __props.loading]]), __props.pagination ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "pagination",
        style: _normalizeStyle({
          justifyContent: _unref(justifyContent)
        })
      }, [_createVNode(_component_el_pagination, {
        currentPage: _unref(currentPageModel),
        "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => _isRef(currentPageModel) ? currentPageModel.value = $event : null),
        "page-size": _unref(pageSizeModel),
        "onUpdate:pageSize": _cache[1] || (_cache[1] = $event => _isRef(pageSizeModel) ? pageSizeModel.value = $event : null),
        "page-sizes": __props.pageSizes,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _unref(_total),
        onSizeChange: _unref(handleSizeChange),
        onCurrentChange: _unref(handleCurrentChange)
      }, null, 8, ["currentPage", "page-size", "page-sizes", "total", "onSizeChange", "onCurrentChange"])], 4)) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(visible) ? visible.value = $event : null),
        width: "680px"
      }, {
        header: _withCtx(() => [_createElementVNode("div", null, [_createTextVNode("自定义表头 "), _createElementVNode("span", _hoisted_6, [_createElementVNode("span", _hoisted_7, [_createTextVNode("已添加"), _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(selected).length), 1), _createTextVNode(" 个")]), _createElementVNode("span", _hoisted_9, "（最多可配" + _toDisplayString(__props.tableColumns.length) + "个表头）", 1)])])]),
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_12, [_createVNode(_component_el_button, {
          onClick: handleCancel
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          loading: _unref(confirmLoading),
          onClick: handleOk
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
          modelValue: _unref(selected),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(selected) ? selected.value = $event : null),
          class: "width100"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tableColumns.filter(item => item.isForce), item => {
            return _openBlock(), _createElementBlock("div", {
              key: item.prop
            }, [_createVNode(_component_el_checkbox, {
              disabled: "",
              label: item.prop
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
              _: 2
            }, 1032, ["label"])]);
          }), 128))]), _createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tableColumns.filter(item => !item.isForce), item => {
            return _openBlock(), _createElementBlock("div", {
              key: item.prop
            }, [_createVNode(_component_el_checkbox, {
              label: item.prop
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
              _: 2
            }, 1032, ["label"])]);
          }), 128))])]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});